import React, { useState } from 'react';

import { GetApp, VisibilityOutlined } from '@mui/icons-material';
import CloseIcon from '@mui/icons-material/Close';
import ImageIcon from '@mui/icons-material/Image';
import PictureAsPdfIcon from '@mui/icons-material/PictureAsPdf';
import VideoFileIcon from '@mui/icons-material/VideoFile';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  IconButton,
  Box,
  Typography,
  styled
} from '@mui/material';
import { enqueueSnackbar } from 'notistack';

import MediaFilesViewerModal from './MediaFilesViewerModal';

const FileListItem = styled(Box)(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  paddingTop: theme.spacing(2),
  paddingBottom: theme.spacing(2),
  '&:last-child': {
    borderBottom: 'none'
  }
}));

const FileInfo = styled(Box)(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  gap: theme.spacing(2)
}));

const FileIcon = styled(Box)(({ theme }) => ({
  width: theme.spacing(6),
  height: theme.spacing(6),
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  borderRadius: '10px',
  backgroundColor: theme.palette.grey[100]
}));

const ActionButtons = styled(Box)(({ theme }) => ({
  display: 'flex',
  gap: theme.spacing(1)
}));

const AttachmentsModal = ({ open, onClose, attachments }) => {
  const [previewOpen, setPreviewOpen] = useState(false);
  const [selectedFile, setSelectedFile] = useState(null);

  const handlePreview = (file) => {
    setSelectedFile(file);
    setPreviewOpen(true);
  };

  const handleDownload = async (url) => {
    try {

      const response = await fetch(url);
      const blob = await response.blob();
      const a = document.createElement("a");
      const objectUrl = URL.createObjectURL(blob);

      a.href = objectUrl;
      a.download = url;
      document.body.appendChild(a);
      a.click();

      // Cleanup
      URL.revokeObjectURL(objectUrl);
      document.body.removeChild(a);
    } catch (e) {
      enqueueSnackbar(e, { variant: 'error' })
    }

  };

  const getFileIcon = (fileType) => {
    if (fileType.includes('image')) {
      return <ImageIcon sx={{ color: 'primary.main', fontSize: 32 }} />;
    } else if (fileType.includes('pdf')) {
      return <PictureAsPdfIcon color="error" sx={{ fontSize: 32 }} />;
    } else if (fileType.includes('video')) {
      return <VideoFileIcon color="action" sx={{ fontSize: 32 }} />;
    }
  };

  return (
    <>
      <Dialog
        open={open}
        onClose={onClose}
        maxWidth="sm"
        fullWidth
        sx={{
          "& .MuiDialog-paper": {
            margin: 0,
            maxHeight: "80vh",
            borderRadius: "10px",
          },
        }}
      >
        <DialogTitle sx={{ display: 'flex', justifyContent: 'space-between', borderBottom: 1, borderColor: '#C7C7C7', alignItems: 'center' }}>
          <Typography variant="h6">Candidates Attachments</Typography>
          <IconButton onClick={onClose} size="small" sx={{ border: 1, borderColor: '#999' }}>
            <CloseIcon />
          </IconButton>
        </DialogTitle>
        <DialogContent>
          {attachments.map((file, index) => (
            <FileListItem key={index}>
              <FileInfo>
                <FileIcon>
                  {getFileIcon(file.type)}
                </FileIcon>
                <Box>
                  <Typography variant="body1" sx={{ fontWeight: 500 }}>
                    {file.name}
                  </Typography>
                </Box>
              </FileInfo>
              <ActionButtons sx={{ gap: 2 }}>
                <IconButton
                  onClick={() => handleDownload(file.url)}
                  size="small"
                  sx={{ border: 1, borderColor: '#999' }}
                >
                  <GetApp />
                </IconButton>
                <IconButton
                  onClick={() => handlePreview(file)}
                  size="small"
                  sx={{ border: 1, borderColor: '#999' }}
                >
                  <VisibilityOutlined />
                </IconButton>
              </ActionButtons>
            </FileListItem>
          ))}
        </DialogContent>
      </Dialog>

      {/* Preview Modal */}
      <MediaFilesViewerModal open={previewOpen} onClose={() => setPreviewOpen(false)} selectedFile={selectedFile} />
    </>
  );
};

export default AttachmentsModal;